import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CartState } from './cart-state.model';

export interface State extends EntityState<CartState> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cart' })
export class CartStateStore extends EntityStore<State, CartState> {
    constructor() {
        super();
    }
}
